import store from '@/store/store';
import getFontsByPairingId from '@/store/Modules/lib/getFontsByPairingId';
import setWeight from '@/store/Modules/lib/setWeight';
import setStyle from '@/store/Modules/lib/setStyle';

export default function getElementCSS(element, args) {
    if (!args.customFont) {
        const pairingId = store.state.websiteDesign.pairingId;
        const pairings = store.state.websiteDesign.pairings;
        const fonts = getFontsByPairingId(pairingId, pairings);

        if (!fonts) {
            return;
        }

        const font = getFontByElementName(fonts, element);

        if (!font) {
            return;
        }

        return assembleCSSPresetFont(font);
    } else {
        const custom1Name = store.state.websiteDesign.font1;
        const custom1Size = store.state.websiteDesign.font1Size ? store.state.websiteDesign.font1Size : 48;
        const custom2Name = store.state.websiteDesign.font2;
        const custom2Size = store.state.websiteDesign.font2Size ? store.state.websiteDesign.font2Size : 16;

        if (custom1Name && custom2Name) {
            if (element === 'h1' ||
                element === 'h2' ||
                element === 'subhead' ||
                element === 'banner'
            ) {
                return assembleCSSCustomFont(custom1Name, custom1Size, element);
            }

            if (element === 'button' ||
                element === 'body'
            ) {
                return assembleCSSCustomFont(custom2Name, custom2Size, element);
            }
        }
    }
}

function assembleCSSCustomFont(fontName, fontSize, element) {
    let size = undefined;
    let lh = undefined;

    const baseSize = parseInt(fontSize) / 16;

    /**
     * Percentage of heading font.
     */
    if (element === 'h1') {
        size = baseSize;
        lh = 1;
    }

    if (element === 'h2') {
        size = (baseSize * 0.9);
    }

    if (element === 'subhead') {
        size = (baseSize * 0.5);
    }

    if (element === 'banner') {
        size = (baseSize * 0.39);
    }

    /**
     * Percentage of body font.
     */
    if (element === 'body') {
        size = baseSize;
    }

    if (element === 'button') {
        size = (baseSize * 1.1);
    }

    const fontData = {
        family: fontName,
        customSize: size,
        lineHeight: lh,
        element: element,
    };

    return writeStyle(fontData);
}

function assembleCSSPresetFont(font) {
    if (!font.family) {
        return;
    }

    const fontData = {
        family: font.family,
        weight: setWeight(font.variant ? font.variant : false),
        italic: setStyle(font.variant ? font.variant : false),
        size: parseInt(font.preview_size) / 16,
        lineHeight: font.preview_line_height,
        letterSpacing: font.preview_letter_spacing,
        allCaps: font.all_caps ? font.all_caps : false,
    };

    return writeStyle(fontData);
}

function writeStyle(fontData) {
    let style = '';

    if (fontData.family) {
        style += 'font-family:' + fontData.family + '!important;';
    }

    if (fontData.weight) {
        style += 'font-weight:' + fontData.weight + '!important;';
    }

    if (fontData.italic) {
        style += 'font-style:' + fontData.italic + '!important;';
    }

    if (fontData.size) {
        style += 'font-size:' + fontData.size + 'rem!important;';
    }

    if (fontData.customSize) {
        style += 'font-size:' + fontData.customSize + 'rem!important;';
    }

    if (fontData.lineHeight) {
        style += 'line-height:' + fontData.lineHeight + '!important;';
    }

    if (fontData.letterSpacing) {
        style += 'letter-spacing:' + fontData.letterSpacing + 'px!important;';
    }

    if (fontData.allCaps) {
        style += 'text-transform:' + 'uppercase' + '!important;';
    }

    return style;
}

function getFontByElementName(fonts, element) {
    return fonts.pairing[element];
}


